import { Injectable } from '@angular/core';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { Subscription } from 'rxjs';
import { LocalStorageSvc } from './localStorage.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsEventsService {

  eventsSubscription:Subscription;
  constructor(public localStorageSvc:LocalStorageSvc) {
  }

  joinAlbumClicked(eventName,isEasyShareAlbum){
    let params = {
      Label : isEasyShareAlbum ? 'easyshare album' : 'regular album'
    }
    this.pushEventToGoogleAnalytics(eventName,params);
  }

  albumJoined(eventName,isEasyShareAlbum,status,reason){
    let params = {};
    if(isEasyShareAlbum){
      params = {
        Action : status,
        Label : status == 'success' ? 'na' : reason,
        General_Data : 'easyshare album'
      }
    }else{
      params = {
        Action : status,
        Label : status == 'success' ? 'na' : reason,
        General_Data : 'regular album'
      }
    }
    this.pushEventToGoogleAnalytics(eventName,params);
  }
 
  pushEventToGoogleAnalytics(eventName,params){
    globalThis.dataLayer = globalThis.dataLayer || [];
    let userId = USER_DETAILS["USER_DETAILS"]["userId"];
    if(userId){
      params["Unique_ID"] = userId;
    }
    params["Entry_Source"] = "Web"
    globalThis.dataLayer.push({
      event: eventName,
      ...params
    });
  }
  
}

export enum GoogleAnalyticsEvents{

  JOIN_ALBUM_CLICKED = "JioCloud_album_joined",
  EASYSHARE_ALBUM_JOINED = "JioCloud_easyshare_Joined"
  
}
